/** The page header's review badge: how many products of the scope's catalogue wait in the
 *  review queue. Only for an integration with catalogue rows (it has a settings registry). */
import { Chip, Tooltip } from '@mui/material';

import type { SyncScope } from '../SyncScopePicker';

import { catalogueScopeOf, useCatalogueRegistry, usePendingReviewCount } from './queries';

export function PendingReviewChip({ scope }: { scope: SyncScope }) {
  const cs = catalogueScopeOf(scope);
  const registry = useCatalogueRegistry(cs);
  const count = usePendingReviewCount(cs, registry.isSuccess);
  if (!count.data) return null;
  return (
    <Tooltip
      describeChild
      title="Products whose upstream change waits for ops — see the catalogue's Review queue tab."
    >
      <Chip
        size="small"
        color="warning"
        label={`${count.data} waiting for review`}
        sx={{ height: 22, fontWeight: 600 }}
      />
    </Tooltip>
  );
}
